import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  appRoot: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column'
  }
}));